export default __webpack_public_path__ + "static/media/ac1c3eb7df4152eb6f3ea5e74aa938a21581510803184.4a668e13.webp";